import React from "react";
import { createRoot } from "react-dom/client";
import TicketCheckIsland from "./TicketCheckIsland";

const mountNode = document.getElementById("ticket-check-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<TicketCheckIsland config={config} />);
  }
}
